import { TRANSMITTAL } from "./actions";
import initialState from "../../../../reducers/initialState";

const TransmittalReducer = (state = initialState, action) =>{


    switch (action.type) {
 
        case TRANSMITTAL.UPDATE_WAITING_TRANSMITTAL_LIST: {
          return {
            ...state,
            waitingTrList: action.waitingTrList,
          };
        }

        case TRANSMITTAL.UPDATE_SELECTED_PEND_TR: {
          return {
            ...state,
            selectedPendTr: action.selectedPendTr,
          };
        }

        case TRANSMITTAL.EDIT_DOCLIST_MODAL: {
          return {
            ...state,
            isEditDoclist: !state.isEditDoclist,
          };
        }

        case TRANSMITTAL.UPDATE_SELECTED_REV_LIST: {
          return {
            ...state,
            selectedRevList: action.selectedRevList,
            isEditDoclist:false

          };
        }

        case TRANSMITTAL.UPDATE_REGISTERED_TR_LIST: {
          return {
            ...state,
            regTrList: action.regTrList,
            

          };
        }
        case TRANSMITTAL.UPDATE_TR_SEARCH: {
          return {
            ...state,
            trSearch: !state.trSearch,
            

          };
        }



        default:
            return state;
    }

}



export default TransmittalReducer;